<template>
  <div class="ecard-management">
    <!-- 电子卡列表 -->
    <div class="table-section">
      <el-card class="table-card">
        <div slot="header" class="card-header">
          <h2 class="page-title">
            电子卡管理
          </h2>
          <div class="header-actions">
            <el-button 
              type="primary" 
              icon="el-icon-plus" 
              @click="handleAddEcard"
              size="small"
            >
              新增电子卡
            </el-button>
            <el-button 
              icon="el-icon-refresh" 
              @click="handleRefresh"
              :loading="loading"
              size="small"
            >
              刷新
            </el-button>
          </div>
        </div>

        <!-- 模块筛选按钮组 -->
        <div class="module-tabs">
          <el-button-group>
            <el-button 
              :type="activeModule === null ? 'primary' : 'default'"
              @click="handleModuleFilter(null)"
            >
              全部
            </el-button>
            <el-button 
              :type="activeModule === 1 ? 'primary' : 'default'"
              @click="handleModuleFilter(1)"
            >
              创新大赛
            </el-button>
            <el-button 
              :type="activeModule === 2 ? 'primary' : 'default'"
              @click="handleModuleFilter(2)"
            >
              大挑
            </el-button>
            <el-button 
              :type="activeModule === 3 ? 'primary' : 'default'"
              @click="handleModuleFilter(3)"
            >
              小挑
            </el-button>
            <el-button 
              :type="isCareerModuleActive ? 'primary' : 'default'"
              @click="handleModuleFilter('career')"
            >
              职规大赛
            </el-button>
            <el-button 
              :type="activeModule === 8 ? 'primary' : 'default'"
              @click="handleModuleFilter(8)"
            >
              新文科大赛
            </el-button>
          </el-button-group>
        </div>

        <!-- 搜索和筛选区域 -->
        <div class="filter-section">
          <el-form :model="searchForm" :inline="true" class="search-form">
            <el-form-item label="关键词">
              <el-input
                v-model="searchForm.keyword"
                placeholder="搜索电子卡名称或密码"
                clearable
                style="width: 200px"
                @keyup.enter.native="handleSearch"
              />
            </el-form-item>
            <el-form-item label="学校名称">
              <el-input
                v-model="searchForm.schoolName"
                placeholder="搜索学校名称"
                clearable
                style="width: 200px"
                @keyup.enter.native="handleSearch"
              />
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.state" placeholder="选择状态" clearable style="width: 120px">
                <el-option label="启用" :value="1" />
                <el-option label="禁用" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="排序方式" class="search-buttons-item">
              <div class="sort-and-buttons">
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>

         <el-table
           v-loading="loading"
           :data="ecardList"
           stripe
           border
           style="width: 100%; table-layout: fixed;"
           empty-text="暂无电子卡数据"
         >
          <el-table-column prop="id" label="ID" width="80" align="center" />
          <el-table-column prop="mark" label="模块" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="getModuleTagType(scope.row.mark)" size="small">
                {{ getModuleName(scope.row.mark) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="电子卡名称" width="120" show-overflow-tooltip align="center" />
          <el-table-column prop="pwd" label="密码" width="160" align="center">
            <template slot-scope="scope">
              <span class="password-text">{{ scope.row.pwd }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="schoolName" label="学校名称" width="140" show-overflow-tooltip align="center" />
          <el-table-column prop="validDate" label="最晚绑卡日期" width="140" align="center">
            <template slot-scope="scope">
              {{ formatDate(scope.row.validDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="endDate" label="失效日期" width="140" align="center">
            <template slot-scope="scope">
              {{ formatDate(scope.row.endDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="bindMax" label="绑定上限" width="120" align="center" />
          <el-table-column prop="bindNow" label="已绑定" width="120" align="center">
            <template slot-scope="scope">
              <span :class="scope.row.bindNow >= scope.row.bindMax ? 'text-danger' : 'text-success'">
                {{ scope.row.bindNow }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state === 1 ? 'success' : 'danger'" size="small">
                {{ scope.row.state === 1 ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                @click="handleViewBindRecords(scope.row)"
              >
                绑卡记录
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          />
        </div>
      </el-card>
    </div>

     <!-- 电子卡新增/编辑对话框 -->
     <el-dialog
       :title="dialogTitle"
       :visible.sync="addDialogVisible"
       width="700px"
       :close-on-click-modal="false"
       @close="handleDialogClose"
     >
       <el-form
         ref="ecardForm"
         :model="ecardForm"
         :rules="ecardRules"
         label-width="120px"
       >
         <!-- 赛事选择区域 -->
         <div class="module-select-section">
           <div class="module-select-header">
             <i class="el-icon-setting"></i>
             <span class="module-select-title">选择赛事模块</span>
           </div>
           <el-form-item label="选择赛事" prop="mark" class="module-select-item">
             <el-select
               v-model="ecardForm.mark"
               placeholder="请选择赛事模块"
               style="width: 100%"
               size="medium"
             >
               <el-option label="新文科" :value="8" />
               <el-option label="创新大赛" :value="1" />
               <el-option label="大挑" :value="2" />
               <el-option label="小挑" :value="3" />
               <el-option label="职规赛-求职简历" :value="4" />
               <el-option label="职规赛-生涯发展报告" :value="5" />
               <el-option label="职规赛-就业能力展示" :value="6" />
               <el-option label="职规赛-生涯发展展示" :value="7" />
             </el-select>
           </el-form-item>
         </div>

         <!-- 分割线 -->
         <div class="form-divider">
           <div class="divider-line"></div>
           <span class="divider-text">电子卡信息</span>
           <div class="divider-line"></div>
         </div>

         <el-form-item label="电子卡名称" prop="name">
           <el-input v-model="ecardForm.name" placeholder="请输入电子卡名称" />
         </el-form-item>
         <el-form-item label="电子卡密码" prop="pwd">
           <el-input v-model="ecardForm.pwd" placeholder="请输入电子卡密码" readonly>
             <el-button slot="append" icon="el-icon-refresh" @click="generatePassword" :loading="passwordGenerating">
               生成密码
             </el-button>
           </el-input>
         </el-form-item>
         <el-form-item label="学校名称" prop="schoolId">
           <el-select
             v-model="ecardForm.schoolId"
             placeholder="请选择学校"
             filterable
             style="width: 100%"
             @focus="loadSchoolList"
           >
             <el-option
               v-for="school in schoolList"
               :key="school.id"
               :label="school.name"
               :value="school.id"
             />
           </el-select>
         </el-form-item>
         <el-form-item label="最晚绑卡日期" prop="validDate">
           <el-date-picker
             v-model="ecardForm.validDate"
             type="datetime"
             placeholder="选择最晚绑卡日期"
             format="yyyy-MM-dd HH:mm:ss"
             value-format="yyyy-MM-dd HH:mm:ss"
             style="width: 100%"
           />
         </el-form-item>
         <el-form-item label="失效日期" prop="endDate">
           <el-date-picker
             v-model="ecardForm.endDate"
             type="datetime"
             placeholder="选择失效日期"
             format="yyyy-MM-dd HH:mm:ss"
             value-format="yyyy-MM-dd HH:mm:ss"
             style="width: 100%"
           />
         </el-form-item>
         <el-form-item label="绑定上限" prop="bindMax">
           <el-input-number
             v-model="ecardForm.bindMax"
             :min="1"
             :max="10000"
             placeholder="绑定上限"
             style="width: 100%"
           />
         </el-form-item>
         <el-form-item label="状态" prop="state">
           <el-radio-group v-model="ecardForm.state">
             <el-radio :label="1">启用</el-radio>
             <el-radio :label="0">禁用</el-radio>
           </el-radio-group>
         </el-form-item>
         <el-form-item label="备注">
           <el-input
             v-model="ecardForm.remark"
             type="textarea"
             :rows="3"
             placeholder="请输入备注信息"
           />
         </el-form-item>
       </el-form>
       <div slot="footer" class="dialog-footer">
         <el-button @click="addDialogVisible = false">取消</el-button>
         <el-button type="primary" @click="handleSubmit" :loading="submitLoading">
           确定
         </el-button>
       </div>
     </el-dialog>

     <!-- 绑卡记录对话框 -->
     <el-dialog
       title="电子卡绑卡记录"
       :visible.sync="bindRecordsDialogVisible"
       width="800px"
       :close-on-click-modal="false"
     >
       <div v-if="selectedEcard" class="bind-records">
         <div class="ecard-info">
           <h4>{{ selectedEcard.name }} - 绑卡记录</h4>
           <p>电子卡密码：<span class="password-text">{{ selectedEcard.pwd }}</span></p>
         </div>
         
         <el-table
           v-loading="bindRecordsLoading"
           :data="bindRecordsList"
           stripe
           border
           style="width: 100%; table-layout: fixed;"
           empty-text="暂无绑卡记录"
           class="bind-records-table"
         >
           <el-table-column prop="id" label="ID" width="80" align="center" />
           <el-table-column prop="userName" label="用户名" width="120" show-overflow-tooltip align="center" />
           <el-table-column prop="userMobile" label="手机号" width="130" align="center" />
           <el-table-column prop="ecardIndex" label="绑定序号" width="100" align="center" />
           <el-table-column prop="expireTime" label="到期时间" width="150" align="center">
             <template slot-scope="scope">
               {{ formatDateTime(scope.row.expireTime) }}
             </template>
           </el-table-column>
           <el-table-column prop="createTime" label="绑定时间" min-width="150" align="center">
             <template slot-scope="scope">
               {{ formatDateTime(scope.row.createTime) }}
             </template>
           </el-table-column>
         </el-table>
         
         <!-- 绑卡记录分页 -->
         <div class="pagination-wrapper" style="margin-top: 16px;">
           <el-pagination
             @size-change="handleBindRecordsSizeChange"
             @current-change="handleBindRecordsCurrentChange"
             :current-page="bindRecordsPagination.current"
             :page-sizes="[10, 20, 50]"
             :page-size="bindRecordsPagination.size"
             layout="total, sizes, prev, pager, next, jumper"
             :total="bindRecordsPagination.total"
           />
         </div>
       </div>
       
       <div slot="footer" class="dialog-footer">
         <el-button @click="bindRecordsDialogVisible = false">关闭</el-button>
       </div>
     </el-dialog>
   </div>
 </template>

<script>
import api from '@/api/api';

export default {
  name: 'EcardManagement',
  data() {
    return {
      loading: false,
      submitLoading: false,
      passwordGenerating: false,
      ecardList: [],
      schoolList: [],
      selectedEcard: null,
      addDialogVisible: false,
      dialogTitle: '新增电子卡',
      bindRecordsDialogVisible: false,
      bindRecordsLoading: false,
      bindRecordsList: [],
      bindRecordsPagination: {
        current: 1,
        size: 10,
        total: 0
      },
      activeModule: null, // 当前激活的模块，null表示全部，'career'表示职规赛
      searchForm: {
        mark: null, // 模块标识，null表示全部
        keyword: '',
        schoolName: '',
        state: null
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      ecardForm: {
        mark: null, // 模块标识，必填
        name: '',
        pwd: '',
        schoolId: null,
        validDate: '',
        endDate: '',
        bindMax: 100,
        state: 1,
        remark: ''
      },
      ecardRules: {
        mark: [
          { required: true, message: '请选择赛事', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入电子卡名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请先生成电子卡密码', trigger: 'blur' }
        ],
        schoolId: [
          { required: true, message: '请选择学校', trigger: 'change' }
        ],
        validDate: [
          { required: true, message: '请选择最晚绑卡日期', trigger: 'change' },
          { validator: this.validateValidDate, trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择失效日期', trigger: 'change' },
          { validator: this.validateEndDate, trigger: 'change' }
        ],
        bindMax: [
          { required: true, message: '请输入绑定上限', trigger: 'blur' }
        ],
        state: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    // 判断职规赛模块是否激活
    isCareerModuleActive() {
      return this.activeModule === 'career';
    }
  },
  mounted() {
    this.loadEcardList();
    this.loadSchoolList();
  },
  methods: {
    // 加载学校列表
    async loadSchoolList() {
      try {
        const response = await api.getSchoolList();
        if (response && response.data && response.data.code === 200) {
          this.schoolList = response.data.data || [];
        } else {
          console.warn('获取学校列表失败:', response?.data?.msg);
          // 如果接口不存在，提供一些默认学校选项
          this.schoolList = [
            { id: 1, name: '北京大学' },
            { id: 2, name: '清华大学' },
            { id: 3, name: '复旦大学' },
            { id: 4, name: '上海交通大学' },
            { id: 5, name: '浙江大学' }
          ];
        }
      } catch (error) {
        console.warn('获取学校列表失败:', error);
        // 提供默认学校选项
        this.schoolList = [
          { id: 1, name: '北京大学' },
          { id: 2, name: '清华大学' },
          { id: 3, name: '复旦大学' },
          { id: 4, name: '上海交通大学' },
          { id: 5, name: '浙江大学' }
        ];
      }
    },

    // 加载电子卡列表
    async loadEcardList(showSuccessMessage = false) {
      this.loading = true;
      try {
        // 如果选择的是职规赛，需要查询多个mark值（4,5,6,7）并合并结果
        // 判断条件：activeModule为'career'，或者searchForm.mark在4-7之间
        const isCareerModule = this.activeModule === 'career' || 
                               (this.searchForm.mark !== null && this.searchForm.mark >= 4 && this.searchForm.mark <= 7);
        
        if (isCareerModule) {
          // 职规赛：查询所有子模块（4,5,6,7）的数据
          const careerMarks = [4, 5, 6, 7];
          const allPromises = careerMarks.map(mark => {
            const params = {
              pageNum: 1,
              pageSize: 1000, // 获取足够多的数据
              mark: mark,
              keyword: this.searchForm.keyword || undefined,
              schoolName: this.searchForm.schoolName || undefined,
              state: this.searchForm.state !== null ? this.searchForm.state : undefined
            };
            return api.getXinWenKeEcardList(params);
          });

          try {
            const responses = await Promise.all(allPromises);
            let allRecords = [];

            responses.forEach(response => {
              if (response && response.data && response.data.code === 200) {
                const responseData = response.data.data;
                const records = responseData.list || responseData.records || [];
                allRecords = allRecords.concat(records);
              }
            });

            // 去重（根据id）
            const uniqueRecords = [];
            const idSet = new Set();
            allRecords.forEach(record => {
              if (!idSet.has(record.id)) {
                idSet.add(record.id);
                uniqueRecords.push(record);
              }
            });

            // 分页处理
            const start = (this.pagination.current - 1) * this.pagination.size;
            const end = start + this.pagination.size;
            this.ecardList = uniqueRecords.slice(start, end);
            this.pagination.total = uniqueRecords.length;

            if (showSuccessMessage) {
              this.$message.success('获取电子卡列表成功');
            }
          } catch (error) {
            console.error('获取职规赛电子卡列表失败:', error);
            this.$message.error('获取职规赛电子卡列表失败，请稍后重试');
          } finally {
            this.loading = false;
          }
          return;
        }

        // 其他模块的正常查询
        // 根据文档：mark=0查询全部模块，不传默认8-新文科，传1-8查询指定模块
        let markValue = undefined;
        if (this.activeModule === null) {
          // 全部模块：传mark=0
          markValue = 0;
        } else if (this.searchForm.mark !== null) {
          // 指定模块：传对应的mark值
          markValue = this.searchForm.mark;
        }
        // 如果markValue仍然是undefined，则不传mark参数，让后端默认查询新文科模块（mark=8）

        const params = {
          pageNum: this.pagination.current,
          pageSize: this.pagination.size,
          keyword: this.searchForm.keyword || undefined,
          schoolName: this.searchForm.schoolName || undefined,
          state: this.searchForm.state !== null ? this.searchForm.state : undefined
        };

        // 只有当markValue不为undefined时才添加mark参数
        if (markValue !== undefined) {
          params.mark = markValue;
        }

         const response = await api.getXinWenKeEcardList(params);
         
         if (response && response.data && response.data.code === 200) {
           // 根据实际API响应结构调整数据解析
           const responseData = response.data.data;
           
           this.ecardList = responseData.list || responseData.records || [];
           this.pagination.total = responseData.total || 0;
           this.pagination.current = responseData.pageNum || responseData.current || 1;
           this.pagination.size = responseData.pageSize || responseData.size || 10;
           
           // 只在明确需要时显示成功提示
           if (showSuccessMessage) {
             this.$message.success('获取电子卡列表成功');
           }
         } else {
           console.error('API响应错误:', response);
           this.$message.error(response?.data?.message || response?.data?.msg || '获取电子卡列表失败');
         }
      } catch (error) {
        console.error('获取电子卡列表失败:', error);
        this.$message.error('获取电子卡列表失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

     // 模块筛选处理（顶部按钮组）
     handleModuleFilter(module) {
       this.activeModule = module;
       if (module === null) {
         // 全部模块：mark设置为null，loadEcardList会传mark=0
         this.searchForm.mark = null;
       } else if (module === 'career') {
         // 职规赛：设置为career标识，loadEcardList会查询多个mark值（4,5,6,7）
         this.searchForm.mark = null; // 职规赛由activeModule标识处理
       } else {
         // 其他模块：设置对应的mark值（1-创新大赛, 2-大挑, 3-小挑, 8-新文科）
         this.searchForm.mark = module;
       }
       this.pagination.current = 1;
       this.loadEcardList();
     },


     // 手动刷新
     handleRefresh() {
       this.loadEcardList(true);
     },

     // 搜索
    handleSearch() {
      this.pagination.current = 1;
      this.loadEcardList();
    },

    // 重置搜索
    handleReset() {
      this.activeModule = null;
      this.searchForm = {
        mark: null,
        keyword: '',
        schoolName: '',
        state: null
      };
      this.pagination.current = 1;
      this.loadEcardList();
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.size = size;
      this.pagination.current = 1;
      this.loadEcardList();
    },

    // 当前页改变
    handleCurrentChange(current) {
      this.pagination.current = current;
      this.loadEcardList();
    },


     // 查看绑卡记录
     handleViewBindRecords(ecard) {
       this.selectedEcard = ecard;
       this.bindRecordsDialogVisible = true;
       this.loadBindRecords();
     },

     // 加载绑卡记录
     async loadBindRecords() {
       if (!this.selectedEcard) return;
       
       this.bindRecordsLoading = true;
       try {
         const params = {
           pageNum: this.bindRecordsPagination.current,
           pageSize: this.bindRecordsPagination.size
         };
         
         const response = await api.getXinWenKeEcardBindRecords(this.selectedEcard.id, params);
         
         if (response && response.data && response.data.code === 200) {
           const responseData = response.data.data;
           this.bindRecordsList = responseData.records || [];
           this.bindRecordsPagination.total = responseData.total || 0;
         } else {
           this.$message.error(response?.data?.msg || '获取绑卡记录失败');
         }
       } catch (error) {
         console.error('获取绑卡记录失败:', error);
         this.$message.error('获取绑卡记录失败，请稍后重试');
       } finally {
         this.bindRecordsLoading = false;
       }
     },

     // 绑卡记录分页大小改变
     handleBindRecordsSizeChange(size) {
       this.bindRecordsPagination.size = size;
       this.bindRecordsPagination.current = 1;
       this.loadBindRecords();
     },

     // 绑卡记录当前页改变
     handleBindRecordsCurrentChange(current) {
       this.bindRecordsPagination.current = current;
       this.loadBindRecords();
     },

     // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const date = new Date(dateStr);
      return date.toLocaleDateString('zh-CN');
    },

     // 获取学校名称
     getSchoolName(schoolId) {
       if (!schoolId) return '-';
       const school = this.schoolList.find(s => s.id === schoolId);
       return school ? school.name : '-';
     },

     // 格式化日期时间
     formatDateTime(dateStr) {
       if (!dateStr) return '-';
       const date = new Date(dateStr);
       return date.toLocaleString('zh-CN');
     },

     // 获取模块名称
     getModuleName(mark) {
       const moduleMap = {
         1: '创新大赛',
         2: '大挑',
         3: '小挑',
         4: '职规赛-求职简历',
         5: '职规赛-生涯发展报告',
         6: '职规赛-就业能力展示',
         7: '职规赛-生涯发展展示',
         8: '新文科模块'
       };
       return moduleMap[mark] || '未知模块';
     },

     // 获取模块标签类型
     getModuleTagType(mark) {
       const typeMap = {
         1: 'primary',
         2: 'success',
         3: 'warning',
         4: 'info',
         5: 'info',
         6: 'info',
         7: 'info',
         8: 'danger'
       };
       return typeMap[mark] || '';
     },

     // 新增电子卡
     handleAddEcard() {
       this.dialogTitle = '新增电子卡';
       this.resetEcardForm();
       this.addDialogVisible = true;
     },

     // 重置表单
     resetEcardForm() {
       this.ecardForm = {
         mark: null,
         name: '',
         pwd: '',
         schoolId: null,
         validDate: '',
         endDate: '',
         bindMax: 100,
         state: 1,
         remark: ''
       };
       if (this.$refs.ecardForm) {
         this.$refs.ecardForm.clearValidate();
       }
     },

     // 对话框关闭
     handleDialogClose() {
       this.resetEcardForm();
     },


     // 生成密码
     async generatePassword() {
       this.passwordGenerating = true;
       try {
         const response = await api.generateXinWenKeEcardPassword();
         if (response && response.data && response.data.code === 200) {
           const password = response.data.data;
           this.generatedPassword = password;
           
           // 如果在新增电子卡对话框中，自动填入密码
           if (this.addDialogVisible) {
             this.ecardForm.pwd = password;
           }
           
           this.$message.success('密码生成成功');
         } else {
           this.$message.error(response?.data?.msg || '密码生成失败');
         }
       } catch (error) {
         console.error('生成密码失败:', error);
         this.$message.error('密码生成失败，请稍后重试');
       } finally {
         this.passwordGenerating = false;
       }
     },


     // 验证最晚绑卡日期
     validateValidDate(rule, value, callback) {
       if (!value) {
         callback(new Error('请选择最晚绑卡日期'));
         return;
       }
       
       const validDate = new Date(value);
       const now = new Date();
       
       // 最晚绑卡日期不能早于当前时间
       if (validDate < now) {
         callback(new Error('最晚绑卡日期不能早于当前时间'));
         return;
       }
       
       // 检查是否与失效日期冲突
       if (this.ecardForm.endDate) {
         const endDate = new Date(this.ecardForm.endDate);
         if (validDate >= endDate) {
           callback(new Error('最晚绑卡日期必须早于失效日期'));
           return;
         }
       }
       
       callback();
     },

     // 验证失效日期
     validateEndDate(rule, value, callback) {
       if (!value) {
         callback(new Error('请选择失效日期'));
         return;
       }
       
       const endDate = new Date(value);
       const now = new Date();
       
       // 失效日期不能早于当前时间
       if (endDate <= now) {
         callback(new Error('失效日期必须晚于当前时间'));
         return;
       }
       
       // 检查是否与最晚绑卡日期冲突
       if (this.ecardForm.validDate) {
         const validDate = new Date(this.ecardForm.validDate);
         if (endDate <= validDate) {
           callback(new Error('失效日期必须晚于最晚绑卡日期'));
           return;
         }
       }
       
       callback();
     },

     // 提交表单
     async handleSubmit() {
       try {
         await this.$refs.ecardForm.validate();
         this.submitLoading = true;
         
         // 获取选中的学校信息
         const selectedSchool = this.schoolList.find(school => school.id === this.ecardForm.schoolId);
         if (!selectedSchool) {
           this.$message.error('请选择有效的学校');
           this.submitLoading = false;
           return;
         }
         
         const formData = {
           mark: this.ecardForm.mark, // 模块标识，必填
           name: this.ecardForm.name,
           password: this.ecardForm.pwd,
           schoolId: this.ecardForm.schoolId,
           schoolName: selectedSchool.name,
           type: 1, // 单次使用
           bindMax: this.ecardForm.bindMax,
           validDate: this.ecardForm.validDate,
           endDate: this.ecardForm.endDate,
           remark: this.ecardForm.remark || ''
         };
         
         const response = await api.createXinWenKeEcard(formData);
         
         if (response && response.data && response.data.code === 200) {
           this.$message.success('电子卡创建成功');
           this.addDialogVisible = false;
           this.loadEcardList();
         } else {
           this.$message.error(response?.data?.msg || '电子卡创建失败');
         }
         
       } catch (error) {
         console.error('创建电子卡失败:', error);
         this.$message.error('创建电子卡失败，请稍后重试');
       } finally {
         this.submitLoading = false;
       }
     }
   }
 };
</script>

<style scoped>
.ecard-management {
  padding: 0;
}

/* 顶部操作栏样式 */
.management-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.management-header .page-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
}

.management-header .page-title i {
  margin-right: 12px;
  color: #f1787f;
  font-size: 28px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

/* 模块筛选按钮组样式 */
.module-tabs {
  margin-bottom: 20px;
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
}

.module-tabs .el-button-group {
  display: flex;
  gap: 0;
}

.module-tabs .el-button {
  border-radius: 0;
  margin-right: 0;
}

.module-tabs .el-button:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.module-tabs .el-button:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* 搜索筛选区域样式 */
.filter-section {
  margin-bottom: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}

.search-form {
  margin: 0;
}

.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 12px;
}

.search-buttons-item .el-form-item__content {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.sort-and-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  flex-shrink: 0;
}

.table-section {
  margin-bottom: 24px;
}

/* 表格内容区域 */
.table-content {
  padding: 20px;
  background: #fff;
}

.table-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.table-card .el-card__body {
  padding: 0 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header .page-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
}

.card-header .page-title i {
  margin-right: 12px;
  color: #f1787f;
  font-size: 24px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.password-text {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #f1787f;
  background: #f5e9ea;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}

.text-success {
  color: #67c23a;
  font-weight: 600;
}

.text-danger {
  color: #f56c6c;
  font-weight: 600;
}

/* 表格内容区域 */
.table-content {
  padding: 20px;
  background: #fff;
}

.pagination-wrapper {
  padding: 20px 0;
  text-align: right;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}


.dialog-footer {
  text-align: right;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .header-actions {
    width: 100%;
    justify-content: flex-end;
  }
  
  .module-tabs {
    padding: 15px;
  }
  
  .module-tabs .el-button-group {
    flex-wrap: wrap;
    width: 100%;
  }
  
  .module-tabs .el-button {
    flex: 1;
    min-width: calc(50% - 4px);
    margin-bottom: 8px;
  }
  
  .module-tabs .el-button:first-child {
    border-radius: 4px 4px 0 0;
  }
  
  .module-tabs .el-button:last-child {
    border-radius: 0 0 4px 4px;
  }
  
  .search-form {
    display: flex;
    flex-direction: column;
  }
  
  .search-form .el-form-item {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .filter-section {
    padding: 15px;
  }
  
  .sort-and-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

/* 表格样式优化 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
}

.el-table th {
  background: #fafbfc;
  color: #222;
  font-weight: 600;
}

.el-table td {
  padding: 12px 0;
}

/* 卡片样式优化 */
.el-card {
  border: 1px solid #f0f0f0;
}

.el-card__header {
  background: #fafbfc;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.el-card__body {
  padding: 20px;
}

/* 按钮样式优化 - 使用 Element UI 默认颜色 */

/* 标签样式优化 */
.el-tag--success {
  background: #f0f9ff;
  color: #67c23a;
  border-color: #b3e19d;
}

.el-tag--danger {
  background: #fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}

.el-tag--primary {
  background: #ecf5ff;
  color: #409eff;
  border-color: #b3d8ff;
}

.el-tag--warning {
  background: #fdf6ec;
  color: #e6a23c;
  border-color: #f5dab1;
}

.el-tag--info {
  background: #f4f4f5;
  color: #909399;
  border-color: #d3d4d6;
}

/* 赛事选择区域样式 */
.module-select-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #f0f2f5 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 15px 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.module-select-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
}

.module-select-header i {
  font-size: 18px;
  color: #409eff;
  margin-right: 8px;
}

.module-select-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.module-select-item {
  margin-bottom: 0;
}

.module-select-item .el-form-item__label {
  font-weight: 600;
  color: #606266;
  font-size: 14px;
}

.module-select-item .el-select {
  max-width: 100%;
}


/* 表单分割线样式 */
.form-divider {
  display: flex;
  align-items: center;
  margin: 24px 0;
  color: #909399;
}

.divider-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, transparent, #e4e7ed, transparent);
}

.divider-text {
  padding: 0 16px;
  font-size: 14px;
  color: #909399;
  white-space: nowrap;
}

/* 分页样式优化 */
.el-pagination {
  text-align: right;
}

.el-pagination .el-pager li.active {
  background: #409eff;
  color: #fff;
}

 .el-pagination .el-pager li:hover {
   color: #409eff;
 }


 /* 绑卡记录样式 */
 .bind-records {
   padding: 16px 0;
 }

 .ecard-info {
   margin-bottom: 20px;
   padding: 16px;
   background: #f5f7fa;
   border-radius: 6px;
   border-left: 4px solid #f1787f;
 }

 .ecard-info h4 {
   margin: 0 0 8px 0;
   color: #222;
   font-size: 16px;
   font-weight: 600;
 }

 .ecard-info p {
   margin: 0;
   color: #666;
   font-size: 14px;
 }

 .ecard-info .password-text {
   font-family: 'Courier New', monospace;
   font-weight: 600;
   color: #f1787f;
   background: #f5e9ea;
   padding: 2px 6px;
   border-radius: 4px;
   font-size: 12px;
 }

 /* 绑卡记录表格样式 - 修复右侧边线对齐 */
 .bind-records-table {
   width: 100% !important;
 }

 .bind-records-table .el-table__body-wrapper,
 .bind-records-table .el-table__header-wrapper {
   width: 100% !important;
 }

 .bind-records-table .el-table__body,
 .bind-records-table .el-table__header {
   width: 100% !important;
 }

 .bind-records-table .el-table__body tr,
 .bind-records-table .el-table__header tr {
   width: 100%;
 }

 /* 确保最后一列去除右边框，消除右侧空白 */
 .bind-records-table .el-table__body tr td:last-child,
 .bind-records-table .el-table__header tr th:last-child {
   border-right: none;
 }

 /* 确保表格完全撑满容器 */
 .bind-records-table {
   border-right: none;
 }

  /* 表格容器样式优化 */
  .table-card {
    overflow-x: auto;
  }

  .table-card .el-card__body {
    padding: 20px 0;
  }

  /* 确保表格占满容器 */
  .el-table {
    width: 100% !important;
  }

  .el-table__body-wrapper {
    width: 100% !important;
  }

  .el-table__header-wrapper {
    width: 100% !important;
  }

 </style>
